import React, { useState, useEffect, useContext } from 'react';
import { removeGroupsFromTestEvent } from '../../../api/testEventApi';
import icon_alert from '../../../assets/images/icon-alert.svg';
import { store } from '../../../utils/store';

export default ({testEvent, groups, showErrorMessage, isQueryPending, onDeleteGroups}) => {

  const { dispatch } = useContext(store);

  const [selectedGroups, setSelectedGroups] = useState([]);
  const [removeGroupsOptions, setRemoveGroupsOptions] = useState([]);

  const removeGroups = () => {
    const data = {
      data: selectedGroups
    }
    removeGroupsFromTestEvent(testEvent.id, data).then(response => {
      onDeleteGroups();
      dispatch({ type: 'SET POPUP', payload: 'success' });
      dispatch({ type: 'SET POPUP MESSAGES', payload: ['Groups Deleted'] });
      setTimeout(() => {
        dispatch({ type: 'SET POPUP', payload: '' })
      }, 3000)
    })
  }

  const changeSelectedGroups = (group) => {
    let removeGroupsOptionsNew = JSON.parse(JSON.stringify(removeGroupsOptions));
    if (group.id === 'all') {
      let allSelected = false;
      removeGroupsOptionsNew.forEach(option => {
        if (option.id === 'all') {
          allSelected = option.checked
        }
      })
      removeGroupsOptionsNew.forEach(option => {
        option.checked = !allSelected;
      })
    } else {
      removeGroupsOptionsNew.forEach(option => {
        if (option.id === group.id) {
          if (option.checked) {
            option.checked = false;
          } else {
            option.checked = true;
          }
        }
      })
    }
    setRemoveGroupsOptions(removeGroupsOptionsNew);
  }

  useEffect(() => {
    let removeGroupsOptions = [{
      label: 'All Groups',
      id: 'all',
      checked: false
    }];
    groups.forEach(group => {
      removeGroupsOptions.push({
        label: group.attributes['name'],
        id: group.id,
        checked: false
      })
    })
    setRemoveGroupsOptions(removeGroupsOptions);
  }, [groups])

  useEffect(() => {
    let selectedGroups = [];
    removeGroupsOptions.forEach(groupOption => {
      if (groupOption.id !== 'all' && groupOption.checked) {
        selectedGroups.push({
          id: groupOption.id,
          type: 'groups'
        })
      }
    })
    setSelectedGroups(selectedGroups);
  }, [removeGroupsOptions])

  return (
    <div className="test-event-groups-form form" >
      <div className="form-instruction">
        Select a group(s) that you would like to <span className="boldFont">remove</span> from this test event.
      </div>
      <div className={`form-content ${showErrorMessage && 'validation-error'}`}>
        <div id="groups-list" className="table">
          <table>
            <tbody className="multiselect-checkboxes">
            {removeGroupsOptions.map(group => (
              <tr key={removeGroupsOptions.indexOf(group)}>
                <td className='column group-name selecting-groups'>
                  <input type="checkbox" id={group.id} checked={group.checked} onChange={() => changeSelectedGroups(group)}/>
                  <label htmlFor={group.id}></label>
                  <div className="truncated">
                    {group.label}
                  </div>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
      {showErrorMessage && (
        <div className='error'>
          <img src={icon_alert} alt="Alert Icon" />
          Please select one or more groups.
        </div>
      )}
      <div className="form-actions">
        <button className="button small red" type="button" disabled={isQueryPending} onClick={removeGroups} >
          Remove Groups
        </button>
      </div>
    </div>
  )
}
